<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="是否限时" prop="isLimitedTime">
                <a-select v-model="queryParam.isLimitedTime" placeholder="请选择是否限时" allow-clear>
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否限一次" prop="isLimitedToOnce">
                <a-select v-model="queryParam.isLimitedToOnce" placeholder="请选择是否限一次" allow-clear>
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态 " prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择状态" allow-clear>
                  <a-select-option :value="0">禁用</a-select-option>
                  <a-select-option :value="1">启用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['played:ingot/config:add']">
          <a-icon type="plus" />新增
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['played:ingot/config:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:ingot/config:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['played:ingot/config:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="limitStartTime" slot-scope="text, record">
          {{ parseTime(record.limitStartTime) }}
        </span>
        <span slot="limitEndTime" slot-scope="text, record">
          {{ parseTime(record.limitEndTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="isLimitedTime" slot-scope="text, record">
          <a-tag v-show="!record.isLimitedTime" color="green">否</a-tag>
          <a-tag v-show="record.isLimitedTime" color="red">是</a-tag>
        </template>
        <template slot="isLimitedToOnce" slot-scope="text, record">
          <a-tag v-show="!record.isLimitedToOnce" color="green">否</a-tag>
          <a-tag v-show="record.isLimitedToOnce" color="red">是</a-tag>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 1" color="green">启用</a-tag>
          <a-tag v-if="record.status === 0" color="red">禁用</a-tag>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['played:ingot/config:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['played:ingot/config:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['played:ingot/config:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listIngotConfig, delIngotConfig } from '@/api/played/ingotConfig'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'IngotConfig',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        isLimitedTime: undefined,
        isLimitedToOnce: undefined,
        limitStartTime: undefined,
        limitEndTime: undefined,
        prices: undefined,
        ingot: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '是否限时',
          dataIndex: 'isLimitedTime',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isLimitedTime' }
        },
        {
          title: '是否限一次',
          dataIndex: 'isLimitedToOnce',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isLimitedToOnce' }
        },
        {
          title: '限时起始时间',
          dataIndex: 'limitStartTime',
          scopedSlots: { customRender: 'limitStartTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '限时截止时间',
          dataIndex: 'limitEndTime',
          scopedSlots: { customRender: 'limitEndTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '充值金额',
          dataIndex: 'prices',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '赠送元宝',
          dataIndex: 'ingot',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '顺序',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          width: 150,
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询银河打本元宝充值配置列表 */
    getList () {
      this.loading = true
      listIngotConfig(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        isLimitedTime: undefined,
        isLimitedToOnce: undefined,
        limitStartTime: undefined,
        limitEndTime: undefined,
        prices: undefined,
        ingot: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delIngotConfig(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('played/ingot/config/export', {
            ...that.queryParam
          }, `ingot/config_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
